<script setup lang="ts">
// Duplication with ClaimButton, which for some reason supported two different props
// post.reward was never present, but we did not know because of the missing types

import { TweetRewardState } from "evangelist-common/enums";
import type { TweetListItemWithCampaignInfo } from "~/common/Types";
const props = defineProps<{
  post: Pick<TweetListItemWithCampaignInfo, "id" | "state">;
}>();

const { $trpc } = useNuxtApp();

const emit = defineEmits(["claimTweet"]);

const claiming = ref(false);

async function claimTweet() {
  claiming.value = true;

  try {
    await $trpc.claimTweet.mutate({
      tweetId: props.post.id,
    });
    emit("claimTweet", props.post.id);
    globalEmit("tweetClaimed", props.post.id);
    successMessage("Tweet claimed!");
  } catch (error) {
    if (error instanceof Error) {
      showError(error);
    } else {
      console.error("Unexpected error:", error);
    }
  } finally {
    claiming.value = false;
  }
}

const claimButtonVisible = computed(() => {
  return [TweetRewardState.Eligible, TweetRewardState.EligibleBonus].includes(
    props.post.state,
  );
});
</script>

<template>
  <button
    v-if="claimButtonVisible"
    :disabled="claiming"
    @click.stop="claimTweet"
  >
    <LoadingIcon v-if="claiming" class="icon" />
    Claim
  </button>
</template>
